(() => {
  const POPUP_SELECTOR = '[data-bodhi-popup]';

  const initBodhiPopup = (popup) => {
    if (!popup || popup.dataset.initialized === 'true') {
      return;
    }

    popup.dataset.initialized = 'true';

    const dialog = popup.querySelector(
      '.bodhi-popup__dialog'
    );

    const form = popup.querySelector(
      '[data-bodhi-popup-form]'
    );

    const formWrapper = popup.querySelector(
      '[data-bodhi-form-wrapper]'
    );

    const success = popup.querySelector(
      '[data-bodhi-success]'
    );

    const submitButton = popup.querySelector(
      '[data-bodhi-submit]'
    );

    const generalError = popup.querySelector(
      '[data-general-error]'
    );

    const closeButtons = popup.querySelectorAll(
      '[data-bodhi-popup-close]'
    );

    if (!dialog || !form) {
      console.warn(
        '[BODHI] Popup encontrado, pero faltan elementos internos.'
      );

      return;
    }

    const delay =
      Number(popup.dataset.delay || 8) * 1000;

    const exitIntentEnabled =
      popup.dataset.exitIntent === 'true';
      
let isOpen = false;
let previousActiveElement = null;
let isSubmitting = false;

/*
 * ----------------------------------------
 * STORAGE
 * ----------------------------------------
 */

/*
 * Cerrar el popup:
 * solo lo oculta durante la sesión actual.
 */
const dismissedKey =
  'bodhi_community_popup_dismissed';

/*
 * Registrarse:
 * lo guarda permanentemente en este navegador.
 */
const subscribedKey =
  'bodhi_community_popup_subscribed';

const hasBeenDismissed = () => {
  try {
    return (
      sessionStorage.getItem(
        dismissedKey
      ) === 'true'
    );
  } catch {
    return false;
  }
};

const markAsDismissed = () => {
  try {
    sessionStorage.setItem(
      dismissedKey,
      'true'
    );
  } catch {
    // Ignore storage errors.
  }
};

const hasSubscribed = () => {
  try {
    return (
      localStorage.getItem(
        subscribedKey
      ) === 'true'
    );
  } catch {
    return false;
  }
};
const markAsSubscribed = () => {
  try {
    localStorage.setItem(
      subscribedKey,
      'true'
    );
  } catch {
    // Ignore storage errors.
  }
};

    /*
     * ----------------------------------------
     * BODY SCROLL
     * ----------------------------------------
     */

    const lockScroll = () => {
      document.documentElement.classList.add(
        'bodhi-popup-open'
      );

      document.body.classList.add(
        'bodhi-popup-open'
      );
    };

    const unlockScroll = () => {
      document.documentElement.classList.remove(
        'bodhi-popup-open'
      );

      document.body.classList.remove(
        'bodhi-popup-open'
      );
    };

    /*
     * ----------------------------------------
     * OPEN
     * ----------------------------------------
     */

    const openPopup = () => {
  if (isOpen) {
    return;
  }

  if (hasBeenDismissed()) {
    return;
  }

  if (hasSubscribed()) {
    return;
  }

      previousActiveElement =
        document.activeElement;

      popup.classList.add('is-open');

      popup.setAttribute(
        'aria-hidden',
        'false'
      );

      lockScroll();

      isOpen = true;

      requestAnimationFrame(() => {
        dialog.focus();
      });

      window.dispatchEvent(
        new CustomEvent(
          'bodhi:popup:viewed'
        )
      );
    };

    /*
     * ----------------------------------------
     * CLOSE
     * ----------------------------------------
     */

    const closePopup = () => {
      if (!isOpen) {
        return;
      }

      popup.classList.remove(
        'is-open'
      );

      popup.setAttribute(
        'aria-hidden',
        'true'
      );

      unlockScroll();

      isOpen = false;

      markAsDismissed();

      if (
        previousActiveElement &&
        typeof previousActiveElement.focus ===
          'function'
      ) {
        previousActiveElement.focus();
      }

      window.dispatchEvent(
        new CustomEvent(
          'bodhi:popup:dismissed'
        )
      );
    };

    closeButtons.forEach((button) => {
      button.addEventListener(
        'click',
        closePopup
      );
    });

    document.addEventListener(
      'keydown',
      (event) => {
        if (!isOpen) {
          return;
        }

        if (event.key === 'Escape') {
          event.preventDefault();

          closePopup();
        }
      }
    );

    /*
     * ----------------------------------------
     * OPEN AUTOMATICALLY
     * ----------------------------------------
     */

    const showAutomatically = () => {

  if (hasBeenDismissed()) {
    return;
  }

  if (hasSubscribed()) {
    return;
  }

  if (
    window.Shopify &&
    window.Shopify.designMode
  ) {
    window.setTimeout(
      openPopup,
      300
    );

    return;
  }

  window.setTimeout(() => {

    if (
      !hasBeenDismissed() &&
      !hasSubscribed()
    ) {
      openPopup();
    }

  }, delay);
};

    /*
     * ----------------------------------------
     * EXIT INTENT
     * ----------------------------------------
     */

    if (exitIntentEnabled) {

      let exitTriggered = false;

      document.addEventListener(
        'mouseout',
        (event) => {

          if (
            exitTriggered ||
            isOpen
          ) {
            return;
          }

          if (
            window.innerWidth <= 749
          ) {
            return;
          }

          if (
            event.clientY <= 0
          ) {

            exitTriggered = true;

            if (
              !hasBeenDismissed() &&
              !hasSubscribed()
            ) {
              openPopup();
            }
          }
        }
      );
    }

    /*
     * ----------------------------------------
     * VALIDATION
     * ----------------------------------------
     */

    const validateEmail = (
      email
    ) => {

      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
        email
      );
    };

    const clearErrors = () => {

      form
        .querySelectorAll(
          '.bodhi-popup__error'
        )
        .forEach((error) => {
          error.textContent = '';
        });

      form
        .querySelectorAll(
          '.has-error'
        )
        .forEach((field) => {
          field.classList.remove(
            'has-error'
          );
        });

      if (generalError) {
        generalError.textContent = '';
      }
    };

    const showFieldError = (
      field,
      message
    ) => {

      const error =
        form.querySelector(
          `[data-error-for="${field}"]`
        );

      if (error) {
        error.textContent =
          message;
      }
    };

    const validateForm = () => {

      clearErrors();

      let valid = true;

      const nameInput =
        form.querySelector(
          '[name="name"]'
        );

      const emailInput =
        form.querySelector(
          '[name="email"]'
        );

      const interest =
        form.querySelector(
          '[name="interest_category"]:checked'
        );

      const name =
        nameInput?.value.trim() || '';

      const email =
        emailInput?.value.trim() || '';

      if (!name) {

        showFieldError(
          'name',
          'Por favor, ingresa tu nombre.'
        );

        nameInput?.classList.add(
          'has-error'
        );

        valid = false;
      }

      if (!interest) {

        showFieldError(
          'interest',
          'Selecciona una opción.'
        );

        valid = false;
      }

      if (!email) {

        showFieldError(
          'email',
          'Por favor, ingresa tu correo electrónico.'
        );

        emailInput?.classList.add(
          'has-error'
        );

        valid = false;

      } else if (
        !validateEmail(email)
      ) {

        showFieldError(
          'email',
          'Ingresa un correo electrónico válido.'
        );

        emailInput?.classList.add(
          'has-error'
        );

        valid = false;
      }

      return valid;
    };

    /*
     * ----------------------------------------
     * LOADING
     * ----------------------------------------
     */

    const setLoading = (
      loading
    ) => {

      if (!submitButton) {
        return;
      }

      submitButton.disabled =
        loading;

      submitButton.classList.toggle(
        'is-loading',
        loading
      );
    };

    /*
     * ----------------------------------------
     * FORM
     * ----------------------------------------
     */

    const handleSubmit =
      async (event) => {

        event.preventDefault();

        if (isSubmitting) {
          return;
        }

        if (!validateForm()) {
          return;
        }

        const nameInput =
          form.querySelector(
            '[name="name"]'
          );

        const emailInput =
          form.querySelector(
            '[name="email"]'
          );

        const interestInput =
          form.querySelector(
            '[name="interest_category"]:checked'
          );

        const name =
          nameInput.value.trim();

        const email =
          emailInput.value
            .trim()
            .toLowerCase();

        const interest =
          interestInput.value;

        isSubmitting = true;

        setLoading(true);

        clearErrors();

        /*
         * KLAVIYO
         *
         * La conexión real se implementará
         * después de comprobar que el popup
         * funciona correctamente.
         */

        try {

  const publicApiKey =
    popup.dataset.klaviyoPublicKey;

  const listId =
    popup.dataset.klaviyoListId;

  if (!publicApiKey || !listId) {
    throw new Error(
      '[BODHI] Faltan las credenciales públicas de Klaviyo.'
    );
  }

  const response = await fetch(
    `https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicApiKey)}`,
    {
      method: 'POST',

      headers: {
        'accept':
          'application/vnd.api+json',

        'content-type':
          'application/vnd.api+json',

        'revision':
          '2026-07-15'
      },

      body: JSON.stringify({
        data: {
          type: 'subscription',

          attributes: {

            custom_source:
              'BODHI Community Popup',

            profile: {
              data: {
                type: 'profile',

                attributes: {

                  email: email,

                  first_name: name,

                  properties: {
                    interest_category:
                      interest,

                    bodhi_signup_source:
                      'Community Popup',

                    bodhi_discount:
                      '10%'
                  },

                  subscriptions: {
                    email: {
                      marketing: {
                        consent:
                          'SUBSCRIBED'
                      }
                    }
                  }
                }
              }
            }
          },

          relationships: {

            list: {
              data: {
                type: 'list',
                id: listId
              }
            }

          }
        }
      })
    }
  );

  if (response.status !== 202) {

    let errorDetails = '';

    try {
      const errorData =
        await response.json();

      errorDetails =
        JSON.stringify(errorData);

    } catch {
      errorDetails =
        `HTTP ${response.status}`;
    }

    console.error(
      '[BODHI] Klaviyo error:',
      errorDetails
    );

    throw new Error(
      'Klaviyo no aceptó la suscripción.'
    );
  }

  /*
   * KLAVIYO ACEPTÓ EL REGISTRO
   */

  markAsSubscribed();

  if (formWrapper) {
    formWrapper.hidden =
      true;
  }

  if (success) {
    success.hidden =
      false;
  }

  window.dispatchEvent(
    new CustomEvent(
      'bodhi:popup:signup',
      {
        detail: {
          name,
          email,
          interest
        }
      }
    )
  );

} catch (error) {

  console.error(
    '[BODHI] Popup error:',
    error
  );

  if (generalError) {
    generalError.textContent =
      'No pudimos completar tu registro. Inténtalo nuevamente.';
  }

} finally {

  isSubmitting =
    false;

  setLoading(false);
}

      };

    form.addEventListener(
      'submit',
      handleSubmit
    );

    /*
     * ----------------------------------------
     * INITIALIZE
     * ----------------------------------------
     */

    showAutomatically();
  };

  /*
   * ----------------------------------------
   * INITIALIZE ALL POPUPS
   * ----------------------------------------
   */

  const initialize = () => {

    document
      .querySelectorAll(
        POPUP_SELECTOR
      )
      .forEach(
        initBodhiPopup
      );
  };

  /*
   * ----------------------------------------
   * INITIAL PAGE LOAD
   * ----------------------------------------
   */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialize,
      {
        once: true
      }
    );

  } else {

    initialize();
  }

  /*
   * ----------------------------------------
   * SHOPIFY THEME EDITOR
   * ----------------------------------------
   */

  document.addEventListener(
    'shopify:section:load',
    (event) => {

      const popup =
        event.target.querySelector?.(
          POPUP_SELECTOR
        );

      if (popup) {
        initBodhiPopup(
          popup
        );
      }
    }
  );

})();